import { Loader } from '../../Loader/Loader';
import React, { FC, Fragment, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface FeatureGuardInternalProps {
  expectedFeature: string;
  availableFeatures: string[];
  loading?: boolean;
  loadingContent?: ReactNode;
  unavailablePlaceholder?: ReactNode;
  children?: React.ReactNode;
}

export const FeatureGuardInternal: FC<FeatureGuardInternalProps> = (props) => {
  const { t } = useTranslation();
  const {
    expectedFeature,
    availableFeatures,
    children,
    unavailablePlaceholder,
    loading,
    loadingContent,
  } = props;
  const matchesRequirement = availableFeatures.some(
    (available) => available.toLocaleLowerCase() === expectedFeature.toLocaleLowerCase(),
  );

  return (
    <>
      {matchesRequirement ? (
        children
      ) : // eslint-disable-next-line unicorn/no-nested-ternary
      loading ? (
        <div className="flex flex-col items-center">
          <Loader />
          <Fragment>
            {loadingContent ?? t('feature_loading', { defaultValue: 'Feature wird geladen...' })}
          </Fragment>
        </div>
      ) : (
        unavailablePlaceholder
      )}
    </>
  );
};

FeatureGuardInternal.displayName = 'FeatureGuardInternal';
